<template>
	<div id="app">
		<Year23 v-if="type===0"></Year23>
		<OneView v-if="type===1"></OneView>
		<TwoView  v-if="type===2"></TwoView>
		<ThreeView  v-if="type===3"></ThreeView>
		<FourView  v-if="type===4"></FourView>
		<FiveView  v-if="type===5"></FiveView>
		<SixView  v-if="type===6"></SixView>
		<SevenView  v-if="type===7"></SevenView>
		<EightView  v-if="type===8"></EightView>
		<TeacherView v-if="type===9"></TeacherView>
		<NineView  v-if="type===10"></NineView>
		<TenView  v-if="type===11"></TenView>
		<ElevenView  v-if="type===12"></ElevenView>
		<Year24  v-if="type===13"></Year24>
		<January25  v-if="type===14"></January25>
		<February25  v-if="type===15"></February25>
		<March25  v-if="type===16"></March25>
		<April25 v-if="type===17"></April25>
		<May25 v-if="type===18"></May25>
		<June25 v-if="type===19"></June25>
		<July25 v-if="type===20"></July25>
		<Auguest25 v-if="type===21"></Auguest25>
		<September25 v-if="type===22"></September25>
		<October25 v-if="type===23"></October25>
		<November25 v-if="type===24"></November25>
		<Year25 v-if="type===25"></Year25>
		<January26 v-if="type===26"></January26>
		<February26 v-if="type===27"></February26>
		<March26 v-if="type===28"></March26>
		<April26 v-if="type===29"></April26>
		<May26 v-if="type===30"></May26>
		<June26 v-if="type===31"></June26>
		<July26 v-if="type===32"></July26>
		<August26 v-if="type===33"></August26>
		<September26 v-if="type===34"></September26>
		<October26 v-if="type===35"></October26>
	</div>
</template>

<script>
import Year23 from './views/Year23.vue'
import OneView from './views/OneView.vue';
import TwoView from './views/TwoView.vue';
import ThreeView from './views/ThreeView.vue';
import FourView from './views/FourView.vue';
import FiveView from './views/FiveView.vue';
import SixView from './views/SixView.vue';
import SevenView from './views/SevenView.vue';
import EightView from './views/EightView.vue';
import TeacherView from './views/TeacherView.vue'
import NineView from './views/NineView.vue';
import TenView from './views/TenView.vue';
import ElevenView from './views/ElevenView.vue';
import Year24 from './views/Year24.vue'
import January25 from './views/25January.vue'
import February25 from './views/25February.vue'
import March25 from './views/25March.vue'
import April25 from './views/25April.vue'
import May25 from './views/25May.vue'
import June25 from './views/25June.vue'
import July25 from './views/25July.vue'
import Auguest25 from './views/25Auguest.vue'
import September25 from './views/25September.vue'
import October25 from './views/25October.vue'
import November25 from './views/25November.vue'
import Year25 from './views/25Year.vue'
import January26 from './views/26January.vue'
import February26 from './views/26February.vue'
import March26 from './views/26March.vue'
import April26 from './views/26April.vue'
import May26 from './views/26May.vue'
import June26 from './views/26June.vue'
import July26 from './views/26July.vue'
import August26 from './views/26August.vue'
import September26 from './views/26September.vue'
import October26 from './views/26October.vue'
export default {
	components:{
		Year23,
		OneView,
		TwoView,
		ThreeView,
		FourView,
		FiveView,
		SixView,
		SevenView,
		EightView,
		TeacherView,
		NineView,
		TenView,
		ElevenView,
		Year24,
		January25,
		February25,
		March25,
		April25,
		May25,
		June25,
		July25,
		Auguest25,
		September25,
		October25,
		November25,
		Year25,
		January26,
		February26,
		March26,
		April26,
		May26,
		June26,
		July26,
		August26,
		September26,
		October26,
	},
	data(){
		return{
			type:14,
		}
	},
	created(){
		var hscr = window.location.href
		if(hscr.indexOf('24January') != -1) {
			this.type = 1
		} else if(hscr.indexOf('24February') != -1){
			this.type = 2
		}else if(hscr.indexOf('24March') != -1){
			this.type = 3
		}else if(hscr.indexOf('24April') != -1){
			this.type = 4
		}else if(hscr.indexOf('24May') != -1){
			this.type = 5
		}else if(hscr.indexOf('24June') != -1){
			this.type = 6
		}else if(hscr.indexOf('24July') != -1){
			this.type = 7
		}else if(hscr.indexOf('24August') != -1){
			this.type = 8
		}else if(hscr.indexOf('teacherDay') != -1){
			this.type = 9
		}else if(hscr.indexOf('24September') != -1){
			this.type = 10
		}else if(hscr.indexOf('24October') != -1){
			this.type = 11
		}else if(hscr.indexOf('24November') != -1){
			this.type = 12
		}else if(hscr.indexOf('year24') != -1){
			this.type = 13
		}else if(hscr.indexOf('25January') != -1){
			this.type = 14
		}else if(hscr.indexOf('25February') != -1){
			this.type = 15
		}else if(hscr.indexOf('25March') != -1){
			this.type = 16
		}else if(hscr.indexOf('25April') != -1){
			this.type = 17
		}else if(hscr.indexOf('25May') != -1){
			this.type = 18
		}else if(hscr.indexOf('25June') != -1){
			this.type = 19
		}else if(hscr.indexOf('25July') != -1){
			this.type = 20
		}else if(hscr.indexOf('25August') != -1){
			this.type = 21
		}else if(hscr.indexOf('25September') != -1){
			this.type = 22
		}else if(hscr.indexOf('25October') != -1){
			this.type = 23
		}else if(hscr.indexOf('25November') != -1){
			this.type = 24
		}else if(hscr.indexOf('25Year') != -1){
			this.type = 25
		}else if(hscr.indexOf('26January') != -1){
			this.type = 26
		}else if(hscr.indexOf('26February') != -1){
			this.type = 27
		}else if(hscr.indexOf('26March') != -1){
			this.type = 28
		}else if(hscr.indexOf('26April') != -1){
			this.type = 29
		}else if(hscr.indexOf('26May') != -1){
			this.type = 30
		}else if(hscr.indexOf('26June') != -1){
			this.type = 31
		}else if(hscr.indexOf('26July') != -1){
			this.type = 32
		}else if(hscr.indexOf('26August') != -1){
			this.type = 33
		}else if(hscr.indexOf('26September') != -1){
			this.type = 34
		}else if(hscr.indexOf('26October') != -1){
			this.type = 35
		}
	}
}
</script>

<style>

</style>